import Model, { JsonArray, JsonObject } from 'src/models/model'
import ReportTableColumn from 'src/models/report/ReportTableColumn'

export function internalSort (rows, sortBy, descending) {
  if (!rows) return []

  const data = [...rows]

  if (sortBy) {
    data.sort((a, b) => {
      if (a.grandTotal) return Number.MAX_VALUE

      const values = _(a).values().map(value => standardSortValue(value))

      if (values.includes('Average')) return Number.MAX_VALUE - 1

      if (values.includes('Total')) return Number.MAX_VALUE

      const x = descending ? b : a
      const y = descending ? a : b

      const xValue = standardSortValue(x[sortBy])
      const yValue = standardSortValue(y[sortBy])

      if (_.isString(xValue) || _.isString(yValue)) {
        // string sort
        return xValue > yValue ? 1 : xValue < yValue ? -1 : 0
      } else {
        // numeric sort
        return parseFloat(xValue) - parseFloat(yValue)
      }
    })
  }

  return data
}

export function standardSortValue (value) {
  if (!value) return value

  if (_.has(value, 'value')) value = value.value

  if (!_.isObject(value)) return value

  return value.sort_value || value.value || value.rating || value.name || value.label
}

export default class ReportTable extends Model {
  static name = 'ReportTable'

  static define () {
    this.fields = {
      title: {
        type: String
      },
      columns: {
        type: [ReportTableColumn]
      },
      tableData: {
        type: JsonObject
      },
      rawData: {
        type: JsonArray
      },
      compactTable: {
        type: Boolean
      },
      descending: {
        type: Boolean
      },
      columnOrder: {
        type: JsonArray
      },
      plainTableContent: {
        type: Boolean
      },
      groupShareColumns: {
        type: JsonArray
      },
      sortBy: {
        type: String
      }
    }

    this.computed = {
      finalCompactTable () {
        if (_.isBoolean(this.compactTable)) return this.compactTable

        if (this.context.currentUser?.isRemote) {
          return this.context.currentUser.compactTablePreference
        }

        return true
      },
      finalPlainTableContent () {
        if (_.isBoolean(this.plainTableContent)) return this.plainTableContent

        if (this.context.currentUser?.isRemote) {
          return this.context.currentUser.plainTableContentPreference
        }

        return false
      }
    }
  }
}
